import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {roomStickerService} from "@/core/service/room.sticker.service";

class RoomStickerApi extends BaseApi {

    constructor() {
        super();
        Room.Sticker = this;

        Room.ready(async e => {
            this._eventListen(this.#Events);
        });
    }

    #Events = {
        room_sticker_set: e => {
            Room.emit(e);
        },
        room_sticker_set_all: e => {
            Room.emit(e);
        },
    }

    async changeRoomUserSticker(params) {
        await roomStickerService.changeRoomUserSticker(params);
    }

    async changeAllRoomUserSticker(params) {
        await roomStickerService.changeAllRoomUserSticker(params);
    }

}

export const RoomSticker = new RoomStickerApi();